import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { resolveImageUrl } from "@/lib/media";
import { PageHeader } from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { YoutubeCard } from "@/components/YoutubeCard";
import { SEO } from "@/components/SEO";

export default function Gallery() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/gallery").then((res) => setItems(res.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="gallery-page">
      <SEO
        title="Gallery"
        description="Photos and videos from PhysioAbhi Healthcare Foundation's physiotherapy sessions, community camps, and patient stories."
        path="/gallery"
      />
      <PageHeader
        eyebrow="Gallery"
        title="Moments of movement and recovery."
        subtitle="A look inside our therapy sessions, community camps, and the people whose lives we've touched."
      />
      <section className="px-5 md:px-10 py-16">
        <div className="max-w-7xl mx-auto">
          {loading && <p data-testid="gallery-loading" className="text-muted-foreground">Loading gallery…</p>}
          {!loading && items.length === 0 && (
            <p data-testid="gallery-empty" className="text-muted-foreground">Gallery content coming soon.</p>
          )}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {items.map((item, i) => (
              <Reveal key={item.id} delay={(i % 3) * 0.08} data-testid={`gallery-item-${item.id}`}>
                {item.type === "video" && item.youtube_id ? (
                  <YoutubeCard youtubeId={item.youtube_id} title={item.title} />
                ) : (
                  <div className="group border border-border overflow-hidden">
                    <div className="aspect-square overflow-hidden">
                      <img src={resolveImageUrl(item.url)} alt={item.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                    </div>
                    <div className="p-4">
                      <h4 className="font-heading text-lg">{item.title}</h4>
                      {item.description && <p className="text-muted-foreground text-sm mt-1">{item.description}</p>}
                    </div>
                  </div>
                )}
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
